import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { INPUTLIST_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
  suggestion: { label: "Suggestion", color: "#FDF2F8", textColor: "#9D174D" },
};

const InputList = () => {
  const [name, setName] = useState("");
  const [nameFilled, setNameFilled] = useState("Omkar");
  const [nameDisabled, setNameDisabled] = useState("");
  const [nameFilledDisabled, setNameFilledDisabled] = useState("Omkar");
  const [nameShadow, setNameShadow] = useState("");
  return (
    <div>
      <div className="grid grid-cols-4 gap-5 my-5 px-3 mb-30">
        <div>
          <FormFieldSet
            label="Input"
            title="Name"
            type="text"
            placeholder="Enter Name"
            value={name}
            onChange={(e) => setName(e)}
            suggestionsList={[
              "Omkar Sahu",
              "Aarav Sharma",
              "Vivaan Patel",
              "Aditya Rao",
              "Krish Mehta",
              "Arjun Nair",
              "Ritvik Menon",
              "Ishaan Verma",
              "Rohan Gupta",
              "Kartik Sinha",
              "Ayaan Mishra",
              "Yuvraj Chauhan",
              "Shivansh Reddy",
              "Daksh Bhandari",
              "Manan Joshi",
              "Harshvardhan Singh",
              "Siddharth Saxena",
              "Lakshay Bansal",
              "Pranav Kulkarni",
              "Devang Shukla",
              "Ananya Gupta",
              "Ishita Patel",
              "Diya Singh",
              "Kritika Mehra",
              "Aadhya Kapoor",
              "Myra Chatterjee",
              "Anvi Nanda",
              "Riya Bajaj",
              "Saanvi Ahuja",
              "Avni Mathur",
              "Aarohi Deshmukh",
              "Tara Iyer",
              "Meera Raman",
              "Sara Malhotra",
              "Nisha Khatri",
              "Pooja Rathore",
              "Charvi Kohli",
              "Mahika Sethi",
              "Shanaya Gill",
              "Aakash Jindal",
              "Rudra Bisht",
              "Keshav Bhatt",
              "Tanishq Rawat",
              "Ritvik Bansal",
              "Tanmay Arora",
              "Shourya Kaushik",
              "Amitabh Dubey",
              "Raghav Khanna",
              "Nakul Vaidya",
              "Suhani Ranka",
              "Radhika Borkar",
              "Nandini Shetty",
              "Tanisha Arvind",
              "Gayatri Phadke",
              "Smriti Kulkarni",
              "Anushka Pillai",
              "Trisha Nambiar",
              "Shrishti Barve",
              "Aisha Godbole",
              "Bhavesh Thakkar",
              "Jeet Solanki",
              "Rakesh Panwar",
              "Sarthak Madaan",
              "Pratik Vora",
              "Jaydeep Panchal",
              "Viraj Gohil",
              "Mayank Trivedi",
              "Chirag Lakhani",
              "Dhruv Vaghani",
              "Kajal Jha",
              "Payal Pradhan",
              "Simran Bedi",
              "Harleen Aulakh",
              "Neha Purohit",
              "Prachi Rane",
              "Ankita More",
              "Mitali Naik",
              "Bhavika Sawant",
              "Sneha Lokhande",
              "Rahul Chavan",
              "Sagar More",
              "Vikas Bhise",
              "Amit Patil",
              "Swapnil Shinde",
              "Nikhil Gawli",
              "Ajay Gaikwad",
              "Prasad Dhamale",
              "Ravindra Powar",
              "Kiran Jagtap",
            ]}
          />
          {name && <p>Value:{name}</p>}
        </div>
        <div>
          <FormFieldSet
            label="Input"
            title="Name"
            type="text"
            placeholder="Enter Name"
            value={nameFilled}
            onChange={(e) => setNameFilled(e)}
            shadow={true}
          />
          {nameFilled && <p>Value:{nameFilled}</p>}
        </div>
        <div>
          <FormFieldSet
            label="Input"
            title="Name"
            type="text"
            placeholder="Enter Name"
            value={nameDisabled}
            onChange={(e) => setNameDisabled(e)}
            disabled={true}
          />
          {nameDisabled && <p>Value:{nameDisabled}</p>}
        </div>
        <div>
          <FormFieldSet
            label="Input"
            title="Name"
            type="text"
            placeholder="Enter Name"
            value={nameFilledDisabled}
            onChange={(e) => setNameFilledDisabled(e)}
            disabled={true}
            shadow={true}
          />
          {nameFilledDisabled && <p>Value:{nameFilledDisabled}</p>}
        </div>
      </div>
      <PropsTable
        data={INPUTLIST_PROPS}
        title="text — Props Reference"
        typeLabel='type="text"'
        categories={CATEGORIES}
      />
    </div>
  );
};

export default InputList;
